module.exports = __webpack_public_path__ + "img/imgd.f3aa68a5.png";